import { all } from 'redux-saga/effects'

import organizationSagas from './organization/sagas'
import planCnpjServicesSagas from './planCnpjServices/sagas'
import planCpfServicesSagas from './planCpfServices/sagas'
import userSagas from './user/sagas'

export default function* rootSaga(_getState) {
  yield all([
    organizationSagas(),
    planCnpjServicesSagas(),
    planCpfServicesSagas(),
    userSagas(),
  ])
}
